import { Link } from "react-router-dom";
import NavItem from "./NavItem";
import styles from "./Menu.module.css";

const Navigation = () => (
  <nav className={styles.nav}>
    <Link to="/" className={styles.logoLink}>
      <img
        src={process.env.PUBLIC_URL + "/images/logo.svg"}
        alt="mWell"
        height="36px"
      />
    </Link>
    <NavItem icon="home" link="/" label="Home" />
    <NavItem icon="calendar_month" link="/appointments" label="Appointments" />
    <NavItem icon="person" link="/profile" label="Profile" />
  </nav>
);

export default Navigation;
